import { Styles } from '../../theme/materialTheme';

export const header: Styles = {
  fontSize: 20,
  fontWeight: 500,
  alignSelf: 'start',
};
